import React, { createContext, useContext, useState } from 'react';

const ScraperContext = createContext();

export function useScraper() {
    return useContext(ScraperContext);
}

export function ScraperProvider({ children }) {
    const [defaultScraperConfig, setDefaultScraperConfig] = useState({
        selectors: {
            product_list: { selector: "", pageType: "list" },
            product_container: { selector: "", pageType: "list" },
            product_name: { selector: "", pageType: "list" },
            price_per_piece: { selector: "", pageType: "list" },
            stock_info: { selector: "", pageType: "list" },
            manufacturer: { selector: "", pageType: "list" },
            product_number: { selector: "", pageType: "list" },
            unique_id: { selector: "", pageType: "list" },
        },
        testing: {
            product_limit: 0,
            enabled: false,
        },
        load_detail_pages: false,
        enable_lazy_scroll: false,
        conversions: [],
    });

    const [scraperConfig, setScraperConfig] = useState(() => {
        // Initialize with default config
        return JSON.parse(JSON.stringify(defaultScraperConfig));
    });

    const [wizardStep, setWizardStep] = useState(1);
    const [patternSuggestions, setPatternSuggestions] = useState({});
    const [executionData, setExecutionData] = useState(null);

    const value = {
        scraperConfig,
        setScraperConfig,
        defaultScraperConfig,
        setDefaultScraperConfig,
        wizardStep,
        setWizardStep,
        patternSuggestions,
        setPatternSuggestions,
        executionData,
        setExecutionData,
    };

    return (
        <ScraperContext.Provider value={value}>
            {children}
        </ScraperContext.Provider>
    );
}